import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { Agenda } from "../../types/agenda";

/** A janela é semiaberta: o fim não entra. */
export const useAgenda = (inicio: string, fim: string) =>
  useQuery({
    queryKey: ["agenda", inicio, fim],
    queryFn: async (): Promise<Agenda> => {
      const { data } = await api.get<Agenda>("/portal-cliente/agenda", {
        params: { inicio, fim },
      });
      return data;
    },
    enabled: Boolean(inicio && fim),
    retry: false,
  });
